import React from 'react';

const Logo = props => {
	return(
		<div>
			<img src="/Logo.svg" alt="logo"/>
		</div>
	);
}

export default Logo;